import React from 'react';
import Navbar from './Navbar';
import '../styles/Layout.css';

/**
 * @param {boolean} useBodyScroll - If true, layout does not create an inner scroll container;
 *   the page flows and the document/body scrolls, so the scrollbar is at the viewport right edge.
 */
const FullWidthLayout = ({ children, useBodyScroll = false }) => {
  const layoutClass = useBodyScroll
    ? 'full-width-layout full-width-layout--body-scroll'
    : 'full-width-layout';
  const contentClass = useBodyScroll
    ? 'full-width-content full-width-content--body-scroll'
    : 'full-width-content';

  return (
    <div className={layoutClass}>
      <Navbar />
      <div className={contentClass}>
        {children}
      </div>
    </div>
  );
};

export default FullWidthLayout;
